import Axios, { AxiosResponse } from 'axios';
import router from '../router';
import { AxiosRequestConfig } from 'axios';
import store from './../store';
const Config = (require("/public/setting") as any).Config;

const blackApiList: string[] = [];
const baseConfig: AxiosRequestConfig = {
    baseURL: Config.GLOBAL_API_ROOT,
    timeout:600000
};
const axios = Axios.create(baseConfig);
const ifAddAuthorization = (config: any): AxiosRequestConfig => {
    // const token = localStorage.getItem('token');
    const token = store.state.token;
    if (token && typeof (token) === 'string' && token !== 'undefined') {
        const url = config.url;
        let isBlack = false;
        for (const api of blackApiList) {
            if (url && url.includes(api)) {
                isBlack = true;
            }
        }
        if (isBlack) {
            delete config.headers.common.Authorization;
        } else {
            config.headers.common.Authorization = '' + 'JWT ' + token;
        }
    } else { }
    return config;
};
axios.interceptors.request.use((config: AxiosRequestConfig) => {
    config = ifAddAuthorization(config);
    return config;
});

axios.interceptors.response.use((value: AxiosResponse) => {
    return value;
}, (error: any) => { });

export default axios;

const resHandle = (VueComponent: any, data: any, loading?: any) => {
    return new Promise((resolve, reject) => {
        if (data.code !== 2000) {
            VueComponent.$message({
                type: "error",
                message: data.msg
            });
            if (loading) {
                loading.close()
            }
            reject(data.msg);
        } else {
            if (loading) {
                loading.close()
            }
            resolve(data);
        }
    });
};

export { resHandle };
